import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule, MatDialogModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { UserinfoComponent } from './userinfo.component';
import { PortraitEditComponent } from './portrait-edit/portrait-edit.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortraitMaskComponent } from './portrait-edit/portrait-mask/portrait-mask.component';

@NgModule({
	declarations: [UserinfoComponent, PortraitEditComponent, PortraitMaskComponent],
	imports: [
		CommonModule,
		FormsModule,
		MatRadioModule,
		MatButtonModule,
		MatDialogModule,
		MatInputModule,
		MatFormFieldModule,
		DragDropModule,
		MatIconModule,

		RouterModule.forChild([{ path: '**', data: SaveStateData, component: UserinfoComponent }])
	],
	entryComponents: [PortraitEditComponent]
})
export class UserinfoModule {}
